import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  background: (p) => p.palette.error[50],
  color: (p) => p.palette.error[700],
};

export const error: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightMedium,
};
